<template>
    <div class="CenDetail">
        <div class="CenDetail-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/network/cenMonitor">CEN</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <Row type="flex" justify="space-between" class="code-row-bg">
            <Col span="6">
                <Card style="height: 480px;">
                    <Row>
                        <Row style="height: 240px;">
                            <Col span="24" style="text-align: center;font-size: 103px;display: block;margin-top: 8px;">
                                <Icon type="ios-globe-outline" />
                            </Col>
                            <Col style="text-align: center;font-size:18px;">{{this.$route.query.name}}</Col>
                        </Row>
                        
                        <Row style="margin-bottom: 20px;">
                            <Col>{{ $t('alarms.network.cen.cenDescription') }}</Col>
                            <Col>---</Col>
                        </Row>
                        <Row>
                            <Col style="margin-bottom: 8px;">{{ $t('alarms.network.cen.cenConfiguration') }}</Col>
                            <Row>
                                <Col span="12">{{ $t('alarms.network.cen.description') }}:</Col>
                                <Col span="10">{{description}}</Col>
                            </Row>
                        </Row>
                    </Row>
                </Card>
            </Col>
            <Col span="13">
                <Card style="height: 480px;">
                    <ul class="content">
                        <li>
                            <Row>
                                <Col span="12">
                                    <Col span="4">
                                        <Button shape="circle" icon="ios-laptop"></Button>
                                    </Col>
                                    <Col span="20">
                                        <Row>
                                            <Col>{{ $t('alarms.network.cen.configurationInformation') }}</Col>
                                            <Row class="host">
                                                <Col>
                                                    <ul>
                                                        <li>{{ $t('alarms.network.cen.name') }}：</li>
                                                        <li>{{name}}</li>
                                                    </ul>
                                                </Col>                                                
                                            </Row>
                                        </Row>
                                    </Col>
                                </Col>
                                <Col span="12">
                                    <Col span="4">
                                        <Button shape="circle" icon="ios-pulse"></Button>
                                    </Col>
                                    <Col span="20">
                                        <Row>
                                            <Col>{{ $t('alarms.common.monitorMessage') }}</Col>
                                            <Row class="host">
                                                <Col>
                                                    <ul>
                                                        <li>{{ $t('alarms.common.monitorItems') }}：</li>
                                                        <li>0 {{ $t('alarms.common.count') }}</li>
                                                    </ul>
                                                </Col>
                                                 <Col>
                                                    <a @click="monitorMQ">{{ $t('alarms.common.viewMonitoringOverview') }}</a>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </Col>
                                </Col>
                            </Row>
                        </li>
                    </ul>
                </Card>
            </Col>
             <Col span="4">
                <Card style="height: 480px;">
                    <Row>
                        <Row style="margin-bottom: 10px;">
                            <Col>{{ $t('alarms.common.tags') }}</Col>
                        </Row>
                        <Row>
                            <Col v-for="(item,index) in tagList" v-bind:key="index">
                                <Tag color="default">{{item.key}} : {{item.value}}</Tag>
                            </Col>
                        </Row>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    import utils from '../../../../utils/utils.js'
    export default {
        name: 'CenDetail',
        data(){
            return {
                id:'',
                accountId:'',
                cenId:'',
                region:'',
                tagList:[],
                name:'',
                accountTypeName:'',
                accountName:'',
                description:''
            }
        },
        mounted () {
            this.queryCenByCenId();
        },
        methods: {
            // 通过cenId查询实例
            queryCenByCenId:function(){
                this.$api.cen.queryCenByCenId({
                    "accountId": this.$route.query.accountId,
                    "cenId": this.$route.query.cenId
                })
                .then(res => {
                    this.description=res.data[0].description;
                    this.name=res.data[0].name;
                });
            },
            // 点击查看监控概览
            monitorMQ: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.cenId=this.$route.query.cenId;
                this.region=this.$route.query.region;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.$router.push({path:'/network/cen/',query: {id: this.id,accountId:this.accountId,cenId:this.cenId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
        
    }
</script>

<style scoped>
    .CenDetail-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .host ul
    {
        list-style: none;
        overflow: hidden;
    }
    .host ul li
    {
        float: left;
    }
    .content>li
    {
        margin-bottom: 6px;
        border-bottom: 1px dashed #ccc;
        padding: 12px;
    }
    .content>li:last-child
    {
        border:none;
    }

</style>



// WEBPACK FOOTER //
// src/components/monitor/network/cen/CenDetail.vue